<template>
<div>
  <b-card>
    <!--
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'operators_excluded.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    -->
    <Grid name="OperatorsExcludedGrid" :preload="preload" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'OperatorsExcludedGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dealer_id': {
          type: 'number'
        }
      },
      url: 'operators_excluded',
      preload: [{
        api: 'dealers/lst',
        field: 'dealer_id'
      }],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '80px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '80px'
      },
      {
        field: 'name',
        title: 'Nome',
        width: '220px'
      },
      {
        field: 'nif',
        title: 'NIF',
        width: '120px'
      },
      {
        field: 'codle',
        title: 'CODLE',
        width: '120px'
      },
      {
        field: 'dealer_id',
        title: 'Distribuidor',
        values:[],
        width: '180px'
      },
      {
        field: 'campaign_excluded',
        title: 'Campaign Excluded',
        width: '150px'
      },
      {
        field: 'stats_excluded',
        title: 'Stats Excluded',
        width: '150px'
      },
      {
        field: 'scorecard_excluded',
        title: 'Scorecard Excluded',
        width: '170px'
      },
      {
        field: 'main_campaign_excluded_operators',
        title: 'Main Campaign Excluded',
        width: '200px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      if (this.$auth.check('operators_excluded.edit')) {
        var route = router.resolve({
          name: 'operators_excluded.edit',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i></a>'
      }
      return ''
    }
  }
}
</script>
